export const HIGH_AVAILABILITY = {
    YES: 'Yes',
    NO: 'No',
};

export const COMMON = {
    YES: 'Yes',
    NO: 'No',
    PRODUCTION: 'Production',
};

export const COSMOSAPITYPES = {
    NOSQL: 'nosql',
    MONGODB: 'mongodb',
    POSTGRESQL: 'postgresql',
    APACHE_CASSANDRA: 'apachecassandra',
    APACHE_GREMLIN: 'apachegremlin',
    TABLE: 'table',
    // node specific
    SINGLE_NODE: 'single node',
};

export default {};
